// Utils Imports
import { parseEnvNumber } from '@/utils/env'

const isDev = process.env.NODE_ENV === 'development'

/**
 * Defaults por entorno (si .env no define valores)
 */
const AUTH_SAFETY_MS_DEFAULT = isDev ? 30_000 : 60_000
const SESSION_UPDATE_AGE_S_DEFAULT = isDev ? 60 : 300
const SESSION_REFETCH_INTERVAL_S_DEFAULT = isDev ? 60 : 300

/**
 * Exporta valores finales leídos desde .env con fallback a defaults
 * - Server: AUTH_SAFETY_MS, SESSION_UPDATE_AGE_S
 * - Client: NEXT_PUBLIC_SESSION_REFETCH_INTERVAL_S
 */
export const AUTH_SAFETY_MS = parseEnvNumber(process.env.AUTH_SAFETY_MS, AUTH_SAFETY_MS_DEFAULT)

export const SESSION_UPDATE_AGE_S = parseEnvNumber(process.env.SESSION_UPDATE_AGE_S, SESSION_UPDATE_AGE_S_DEFAULT)

/**
 * En el cliente sólo existen variables con NEXT_PUBLIC_
 */
export const SESSION_REFETCH_INTERVAL_S = parseEnvNumber(
  process.env.NEXT_PUBLIC_SESSION_REFETCH_INTERVAL_S,
  SESSION_REFETCH_INTERVAL_S_DEFAULT
)
